module.exports = __webpack_public_path__ + "img/galleria3.79e3b59.jpg";


//////////////////
// WEBPACK FOOTER
// ./showcase/src/assets/images/demo/galleria/galleria3.jpg
// module id = 4cFB
// module chunks = 0